import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { useAfterHoursOverrideStore } from "@/store/after-hours-override-store";

/** Renders an AlertDialog when the backend returns
 *  ``409 { code: "after_hours_override_required" }`` on a reservation
 *  create / update. The slot lies past the public closing hour but
 *  inside the staff-only extension window — confirming opts in. */
export function AfterHoursOverrideDialog() {
  const pending = useAfterHoursOverrideStore((s) => s.pending);
  const close = useAfterHoursOverrideStore((s) => s.close);

  const ctx = pending?.context;
  return (
    <AlertDialog
      open={pending !== null}
      onOpenChange={(open) => {
        if (!open) close(false);
      }}
    >
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Reserva después del cierre público</AlertDialogTitle>
          <AlertDialogDescription>
            {ctx ? (
              <>
                Esta reserva{" "}
                {ctx.starts_after_close ? (
                  <>
                    empieza a las <strong>{ctx.slot_local_time}</strong>
                  </>
                ) : (
                  <>
                    es de <strong>{ctx.slot_local_time}</strong>
                    {ctx.slot_local_ends_time ? (
                      <>
                        {" "}
                        a <strong>{ctx.slot_local_ends_time}</strong>
                      </>
                    ) : null}
                  </>
                )}
                {ctx.public_close_time ? (
                  <>
                    {" "}
                    y se extiende después del cierre público (
                    <strong>{ctx.public_close_time}</strong>)
                  </>
                ) : null}
                . Los comensales no pueden reservar a esta hora, pero el equipo puede crearla
                manualmente hasta {ctx.extension_minutes} minutos después del cierre.
                <br />
                <br />
                ¿Confirmar y crear igual?
              </>
            ) : null}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={() => close(false)}>Cancelar</AlertDialogCancel>
          <AlertDialogAction onClick={() => close(true)}>Confirmar y crear</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
